module.exports = __webpack_public_path__ + "assets/img/d34404c196cf7d955f9a726de7540248.png";